import { RefObject, useEffect } from 'react';

export default function useOnOutsideElementClick(
  elementRef: RefObject<HTMLElement | null>,
  onOutsideElementClick: () => void
) {
  useEffect(() => {
    function handleClickOutside(event: TouchEvent | MouseEvent) {
      if (
        elementRef?.current &&
        !elementRef?.current?.contains(event.target as Node)
      ) {
        onOutsideElementClick();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [elementRef, onOutsideElementClick]);
}
